import React, { useEffect } from "react";

import Navbar from "./clientHom/Navbar";
import CustomDevelopmentHero from "./customSystems/CustomDevelopmentHero";
import CustomDevelopmentPageNavigation from "./customSystems/CustomDevelopmentPageNavigation";
import CustomDevelopmentOperationalFriction from "./customSystems/CustomDevelopmentOperationalFriction";
import CustomDevelopmentSystemDefinition  from "./customSystems/CustomDevelopmentSystemDefinition";
import CustomDevelopmentDiscoveryMapping from "./customSystems/CustomDevelopmentDiscoveryMapping";
import CustomDevelopmentWhatWeBuild from "./customSystems/CustomDevelopmentWhatWeBuild";
import CustomDevelopmentProcessTransformation from "./customSystems/CustomDevelopmentProcessTransformation";
import CustomDevelopmentDeliveryProcess from "./customSystems/CustomDevelopmentDeliveryProcess";
import CustomDevelopmentProductProof from "./customSystems/CustomDevelopmentProductProof";
import CustomDevelopmentResponsibleAI from "./customSystems/CustomDevelopmentResponsibleAI";
import CustomDevelopmentImplementationAdoption from "./customSystems/CustomDevelopmentImplementationAdoption";
import CustomDevelopmentEngagementRoutes from "./customSystems/CustomDevelopmentEngagementRoutes";

import Footer from "./uniComponents/AndUsFooter";

import "./CustomSystemsPage.css";

export default function CustomSystemsPage() {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "Custom Intelligent Systems | AndUs";
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="custom-systems-public-page">
      <Navbar />

      <main className="custom-systems-public-page__main">
        {/*
          Future Custom Systems landing-page components must be imported
          from src/pages/customSystems and placed here.
        */}
        <CustomDevelopmentHero />
        <CustomDevelopmentPageNavigation />
        <CustomDevelopmentOperationalFriction />
        <CustomDevelopmentSystemDefinition />
        <CustomDevelopmentDiscoveryMapping />
        <CustomDevelopmentWhatWeBuild />
        <CustomDevelopmentProcessTransformation />
        <CustomDevelopmentDeliveryProcess />
        <CustomDevelopmentProductProof />
        <CustomDevelopmentResponsibleAI />
        <CustomDevelopmentImplementationAdoption />
        <CustomDevelopmentEngagementRoutes />
        <div
          id="custom-systems-page-content"
          className="custom-systems-public-page__development-anchor"
          aria-hidden="true"
        />
      </main>

      <Footer />
    </div>
  );
}